import React from "react";
import PropTypes from "prop-types";
import { GatsbyImage } from "gatsby-plugin-image";

export const CallToAction = ({
  image,
  badge,
  title,
  content,
  buttonLink,
  buttonText,
  id
}) => {
  return (
    <div
      id={id}
      className="col-12 row align-items-center article-cta bg-primary-alt"
    >
      <div className="col-md-6">
        <GatsbyImage image={image.gatsbyImageData} alt={image.alt} loading="lazy" />
      </div>
      <div className="col-md-6">
        <span className="badge badge-primary-2">{badge}</span>
        <h3 className="mt-2 h2">{title}</h3>
        <p>{content}</p>
        <a
          className="btn btn-primary btn-lg text-light"
          href={buttonLink}
          target="_blank"
          rel="noreferrer"
        >
          {buttonText}
        </a>
      </div>
    </div>
  );
};

CallToAction.propTypes = {
  image: PropTypes.object.isRequired,
  badge: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  id: PropTypes.string
};
